import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingSteel,
  manufacturingProcess,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: 'Ngành công nghiệp sản xuất chịu ảnh hưởng lớn từ những đổi mới công nghệ, và trong những năm gần đây, một khái niệm mang tính cách mạng được gọi là nhà máy thông minh đang đóng vai trò to lớn trong việc đổi mới ngành sản xuất và nâng cao hiệu quả sản xuất.',
  keywords:
    'Nhà máy thông minh, sản xuất thông minh, dây chuyền sản xuất, quản lý hàng kho, nha may thong minh, san xuat thong minh, day chuyen san xuat, quan ly hang kho.',
  ogSite: 'Cách nhà máy thông minh đang thay đổi ngành công nghiệp sản xuất',
  title: 'Cách nhà máy thông minh đang thay đổi ngành công nghiệp sản xuất',
  ogUrl: 'https://orbro.io/vi/blog/smartFactory',
  ogImg: '',
  ogType: 'website',
  date: '2023-10-12',
  tag1: '#Nhamaythongminh',
  tag2: '#Sanxuatthongminh',
  tag3: '#Daychuyensanxuat',
  tag4: '#Quanlyhangkho',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Ngành công nghiệp sản xuất chịu ảnh hưởng lớn từ những đổi mới công nghệ, và trong những năm gần đây, một khái niệm mang tính cách mạng được gọi là nhà máy thông minh đang đóng vai trò to lớn trong việc đổi mới ngành sản xuất và nâng cao hiệu quả sản xuất. Một trong những yếu tố cốt lõi của các nhà máy thông minh này chính là công nghệ Hệ thống Định vị Thời gian Thực (Real-Time Location System - RTLS). Công nghệ RTLS là công nghệ theo dõi vị trí và chuyển động của tài sản cũng như người lao động trong các cơ sở sản xuất theo thời gian thực, đóng vai trò giúp các nhà sản xuất tối ưu hóa quy trình sản xuất và tối đa hóa hiệu quả. Trong bài viết này, chúng ta sẽ thảo luận về cách công nghệ RTLS được áp dụng trong các nhà máy thông minh và hiệu quả của nó đang làm thay đổi ngành công nghiệp sản xuất như thế nào.',
      dot: '',
    },
    {
      head: 'RTLS là gì? ',
      subHead: '',
      desc: `RTLS là viết tắt của 'Real-Time Location System', có nghĩa là hệ thống theo dõi vị trí thời gian thực. Công nghệ này cho phép xác định và giám sát chính xác vị trí của các yếu tố có tính di động như người lao động hoặc thiết bị. Hệ thống RTLS sử dụng GPS, RFID (Nhận dạng qua tần số vô tuyến), UWB (Băng thông siêu rộng), Bluetooth, sóng siêu âm và các cảm biến khác để theo dõi vị trí của người lao động.`,
      dot: '',
    },
    {
      head: 'Tối ưu hóa phân bổ nguồn lực',
      subHead: '',
      desc: 'Thông qua RTLS, có thể nắm bắt vị trí của nguyên vật liệu, linh kiện, người lao động và máy móc theo thời gian thực, do đó có thể tối ưu hóa việc phân bổ nguồn lực. Điều này giúp nâng cao hiệu quả của dây chuyền sản xuất và thiết bị, đồng thời giảm lãng phí tài nguyên.',
      dot: '',
    },
    {
      head: 'Bảo trì và bảo dưỡng phòng ngừa',
      subHead: '',
      desc: 'RTLS được sử dụng để giám sát tình trạng của máy móc và thiết bị, đồng thời tối ưu hóa lịch trình bảo trì và bảo dưỡng phòng ngừa. Việc phát hiện sớm những thay đổi về tình trạng hoặc hỏng hóc của máy móc có thể ngăn chặn sự gián đoạn sản xuất và giảm chi phí.',
      dot: '',
    },
    {
      head: 'Giám sát dữ liệu sản xuất theo thời gian thực',
      subHead: '',
      desc: 'RTLS có thể thu thập và giám sát dữ liệu phát sinh trong cơ sở sản xuất theo thời gian thực. Thông qua đó, có thể nắm bắt tình trạng thực tế của quy trình sản xuất và nhanh chóng ứng phó nếu có sự cố phát sinh trong quá trình sản xuất.',
      dot: '',
    },
    {
      head: 'Dịch vụ khách hàng và nâng cao chất lượng',
      subHead: '',
      desc: 'RTLS có thể được sử dụng để theo dõi quy trình sản xuất và ghi lại lịch sử của sản phẩm. Qua đó, có thể quản lý chất lượng sản phẩm và cải thiện dịch vụ khách hàng.',
      dot: '',
    },
    {
      head: 'Sản xuất thân thiện với môi trường',
      subHead: '',
      desc: 'Bằng cách sử dụng công nghệ RTLS, có thể tối ưu hóa việc sử dụng năng lượng và tài nguyên, đồng thời hiện thực hóa sản xuất thân thiện với môi trường. Ngoài ra, có thể tuân thủ các quy định về môi trường và tăng cường sản xuất xanh.',
      dot: '',
    },
    {
      head: 'Quản lý hàng tồn kho tự động hóa',
      subHead: '',
      desc: 'RTLS được sử dụng để tự động hóa việc quản lý hàng tồn kho và tối ưu hóa mức tồn kho. Điều này giúp giảm chi phí quản lý hàng tồn kho và sử dụng không gian một cách hiệu quả.',
      dot: '',
    },
    {
      head: 'Trực quan hóa hiện trường sản xuất theo thời gian thực',
      subHead: '',
      desc: 'RTLS được ứng dụng để trực quan hóa quy trình sản xuất theo thời gian thực. Thông qua đó, có thể nắm bắt rõ ràng tình hình tại hiện trường sản xuất và giám sát quy trình sản xuất.',
      dot: '',
    },
    {
      head: 'Rút ngắn thời gian xử lý đơn hàng và chu kỳ sản xuất',
      subHead: '',
      desc: 'Thông qua RTLS, có thể rút ngắn thời gian xử lý đơn hàng và chu kỳ sản xuất, đồng thời đáp ứng nhanh chóng các yêu cầu của khách hàng.',
      dot: '',
    },
    {
      head: 'Kiểm tra chất lượng và quản lý chất lượng',
      subHead: '',
      desc: 'Bằng cách sử dụng RTLS, có thể tăng cường công tác kiểm tra chất lượng sản phẩm và quản lý chất lượng. Có thể xác định các sản phẩm lỗi và nhanh chóng thực hiện các biện pháp để giải quyết các vấn đề về chất lượng.',
      dot: '',
    },
    {
      head: 'Tính minh bạch của quy trình sản xuất',
      subHead: '',
      desc: 'RTLS được sử dụng để nâng cao tính minh bạch của quy trình sản xuất và theo dõi lỗi theo thời gian thực. Thông qua đó, có thể xác định các điểm cần cải thiện trong quy trình sản xuất và nâng cao hiệu quả.\n\nĐể áp dụng thành công công nghệ RTLS vào các cơ sở sản xuất, cần có cơ sở hạ tầng phần cứng và phần mềm phù hợp. Ngoài ra, việc xem xét đến bảo mật dữ liệu và bảo vệ thông tin cá nhân cũng rất quan trọng. Tuy nhiên, ngay cả khi đối mặt với những thách thức này, tiềm năng của công nghệ RTLS mang lại những lợi thế to lớn cho các nhà sản xuất hiện đại.\n\nSự kết hợp giữa nhà máy thông minh và công nghệ RTLS là một trong những phương pháp quan trọng để phát triển ngành công nghiệp sản xuất. Thông qua đó, các nhà sản xuất có thể nâng cao hiệu quả, tối ưu hóa quy trình sản xuất, duy trì và nâng cao năng lực cạnh tranh. Do đó, công nghệ RTLS đóng một vai trò quan trọng trong việc vẽ nên một tương lai tươi sáng cho ngành công nghiệp sản xuất.\n',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: manufacturingProcess.thumb,
        data: 'manufacturingProcess',
        link: '/vi/enterprise/manufacturing/process',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/vi/enterprise/manufacturing/steel',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
